"use strict"; // Thanks JavaScript-Load-Image repo
// https://github.com/blueimp/JavaScript-Load-Image/blob/1e4df707821a0afcc11ea0720ee403b8759f3881/js/load-image-orientation.js#L37-L53

var _regeneratorRuntime = require("/builds/zonotho/Zonotho-2-0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/builds/zonotho/Zonotho-2-0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBrowserOrientation = void 0;

var readImage_1 = require("./readImage");

function getBrowserOrientation() {
  return _getBrowserOrientation.apply(this, arguments);
}

function _getBrowserOrientation() {
  _getBrowserOrientation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var testImageURL, img;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // black 2x1 JPEG, with the following meta information set:
            // EXIF Orientation: 6 (Rotated 90° CCW)
            testImageURL = 'data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAA' + 'AAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBA' + 'QEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQE' + 'BAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAEAAgMBEQACEQEDEQH/x' + 'ABKAAEAAAAAAAAAAAAAAAAAAAALEAEAAAAAAAAAAAAAAAAAAAAAAQEAAAAAAAAAAAAAAAA' + 'AAAAAEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwA/8H//2Q==';
            _context.next = 3;
            return readImage_1.readImage(testImageURL);

          case 3:
            img = _context.sent;
            return _context.abrupt("return", img.width === 1 && img.height === 2);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getBrowserOrientation.apply(this, arguments);
}

exports.getBrowserOrientation = getBrowserOrientation;